import { toNumber } from 'lodash';
import trashImg from '../images/Lixeira.png';

interface TrashProps {
  onclick: () => void;
  pos: { x: number; y: number };
  scale: number;
  isLogicMaker: boolean;
  css: any;
  dropArea?: any;
  id?: string;
  size;
}

export const Trash: React.FC<TrashProps> = ({ onclick,css,isLogicMaker,pos,size,dropArea,id }) => {
  return (
    <img
    id={id}
    draggable={false}
      onClick={onclick}
      src={trashImg}
      alt="Lixeira para colocar variáveis inválidas"
      style={{
        height: isLogicMaker? '85% !important' : size.y,
        width: isLogicMaker? '85%' : size.x,
        display: 'block',
        margin: 'auto',
        ...css
      }}
    />
  );
};

